<template>
  <div class="issue">
    <page-header
      title="ISSUES"
    >
      <template #action>
        <v-btn color="button" @click="goBack">
          BACK
        </v-btn>
      </template>
      <template #breadcrumbs>
        <router-link :to="{ name: 'issues' }">
          Issues
        </router-link>
        <span>
          / {{ issue.title }}
        </span>
      </template>
    </page-header>

    <div class="issue__content">
      <v-row>
        <v-col cols="12" md="4">
          <IssueDetailsCard :issue="issue" />
        </v-col>
        <v-col cols="12" md="8">
          <IssueMessagesCard
            ref="issueMessages"
            :messages="issue.messages"
            :reply="isNotCompleted"
            :processing="isSubmitProcessing"
            @submit="sendMessage"
          />
        </v-col>
      </v-row>
    </div>

    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import IssueDetailsCard from '@/components/IssueDetailsCard.vue';
import IssueMessagesCard from '@/components/IssueMessagesCard.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  metaInfo() {
    return {
      title: `Issue - ID:${this.issue.id}`,
    };
  },

  components: {
    PageHeader,
    IssueDetailsCard,
    IssueMessagesCard,
    ConfirmDialog,
  },

  props: {
    issuesId: {
      type: [String, Number],
      required: true,
    },
  },

  computed: {
    ...mapState('issue', [
      'issue',
      'isSubmitProcessing',
    ]),

    isNotCompleted() {
      return this.issue.status !== 'Completed';
    },
  },

  created() {
    this.fetchIssue(this.issuesId);
  },

  methods: {
    ...mapActions('issue', [
      'fetchIssue',
      'submitIssueMessage',
    ]),

    goBack() {
      this.$router.push({ name: 'issues' });
    },

    sendMessage(message) {
      const issueData = {
        id: this.issuesId,
        message,
      };
      this.submitIssueMessage(issueData)
        .then(() => {
          this.$refs.issueMessages.message = '';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.issue {
  &__actions {
    margin-top: 12px;
    text-align: right;
  }

  &__content {
    margin-top: 12px;
  }
}
</style>
